<script lang="ts">
  import RoundImageContainer from "@shared/svelte/Components/RoundImageContainer.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import {
    BrowseByAdEntity,
    BrowseByContentCardEntity,
  } from "@shared/services/event_tracking/entities";
  import { getCloudinaryUrl } from "@shared/services/cloudinary_image_url_service";
  import { cloudinaryParams } from "@shared/services/discovery_image_dimensions";

  import type { PaidTrackingValues } from "@shared/types/PaidTrackingValues";

  export let contentClass: string;
  export let contentValueId: number;
  export let contentValueName: string;
  export let forwardStateParams: any;
  export let imageAltText: string;
  export let imageUrl: string;
  export let layoutPosition: string;
  export let browseByAdTrackingValues: PaidTrackingValues | null = null;

  const forwardStateName: string = "layout.product_listing";

  // If the image is not a sponsored image, it will be in IMAGE_PATHS.
  // Otherwise, the server will serve the full url.
  const cloudinaryImageParams = cloudinaryParams.browseBy;
  const fullImageUrl: string =
    window["C"].IMAGE_PATHS[imageUrl] || getCloudinaryUrl(imageUrl, cloudinaryImageParams);

  const trackingParams: (BrowseByContentCardEntity | BrowseByAdEntity)[] = [];
  const browseByCardParams: BrowseByContentCardEntity = new BrowseByContentCardEntity({
    content_class: contentClass,
    content_value_id: contentValueId,
    content_value_name: contentValueName,
    forward_state_name: forwardStateName,
    forward_state_params: forwardStateParams,
    image_asset_type: "lifestyle",
    image_asset_url: fullImageUrl,
    layout_position: layoutPosition,
  });

  trackingParams.push(browseByCardParams);

  if (browseByAdTrackingValues) {
    const browseByAdParams: BrowseByAdEntity = new BrowseByAdEntity({
      ...browseByAdTrackingValues,
      image_url: imageUrl,
    });

    trackingParams.push(browseByAdParams);
  }
</script>

<TrackingContext entities={trackingParams} let:trackingContext>
  <div data-testid="browse-by-content-card-{contentClass}-{contentValueId}">
    <RoundImageContainer
      {forwardStateName}
      {forwardStateParams}
      imageUrl={fullImageUrl}
      {imageAltText}
      text={contentValueName}
    />
  </div>
</TrackingContext>
